import { TransportMode } from '../../../../../../../../models/transport-mode.enum';
import DataUrlHelper from '../../../../../../../../helpers/data-url.helper';
import { TranslationService } from '../../../../../../../../services/translation.service';
import { DistanceHelper } from '../../../../../../../../helpers/distance.helper';
import { DateHelper } from '../../../../../../../../helpers/date.helper';
import greaterThanIcon from '../../../../../../../../../assets/icons/chevron-right-default-gray-900.svg';
import { Icon } from '../../../../../../../Shared/Icon';
import { TransportModeHelper } from '../../../../../../../../helpers/transport-mode.helper';

function getActivityName(transportMode: TransportMode): string {
  if (transportMode === TransportMode.walk) {
    return TranslationService.get('common.activity.walk');
  }
  if (transportMode === TransportMode.bike) {
    return TranslationService.get('common.activity.bike');
  }
  if (transportMode === TransportMode.car) {
    return TranslationService.get('common.activity.drive');
  }
  return '';
}

function TravelTo({
  transportMode,
  durationInMinutes,
  distanceInMeters,
  showLinkIcon = false,
}: {
  transportMode: TransportMode;
  durationInMinutes: number | undefined;
  distanceInMeters: number | undefined;
  showLinkIcon?: boolean;
}) {
  return (
    <div className="bg-gray rounded p-3 travel-to d-flex align-items-center">
      <div className="flex-grow-1 d-flex align-items-center">
        <Icon {...TransportModeHelper.getIcon(transportMode)} altText="" className="me-1" />
        <span>{getActivityName(transportMode)}&nbsp;</span>
        {transportMode === TransportMode.walk && distanceInMeters !== undefined && distanceInMeters > 0 && <span className="text-nowrap">{DistanceHelper.format(distanceInMeters)}&nbsp;</span>}
        {transportMode !== TransportMode.walk && durationInMinutes !== undefined && durationInMinutes > 0 && (
          <span className="text-nowrap">{DateHelper.formatAsHoursAndMinutes(durationInMinutes)}&nbsp;</span>
        )}
      </div>
      {showLinkIcon && <img src={DataUrlHelper.encode(greaterThanIcon)} alt="" className="flex-shrink-0 align-self-center trip-leg__button-icon d-print-none" />}
    </div>
  );
}

export default TravelTo;
